import React, { useEffect, useState } from 'react';

// PropType definition
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
;

// Header component with props and its types
const _Pagination = props => {
  const {
    totalRecords,
    pageSize,
    pageNumber,
    onTriggerPaginationChange
  } = props;
  // Declared the states needed for this component
  const [currentPage, setCurrentPage] = useState(pageNumber);
  const [goToPageNumber, setGoToPageNumber] = useState('');
  const [pageArray, setPageArray] = useState([]);
  const [hasNextPage, setNextPage] = useState(false);
  const [hasPreviousPage, setPrevPage] = useState(false);
  const [totalPageNumber, setTotalPageNumber] = useState(Math.ceil(totalRecords / pageSize));

  // Initial component rendering calculation is done in this use effect.
  useEffect(() => {
    setTotalPageNumber(Math.ceil(totalRecords / pageSize));
    processFlow(pageNumber);
  }, [totalPageNumber, pageNumber, totalRecords]);

  // Main function used to calculate the logic of pagination
  // This function will set the current page , total page and page number need to show.
  const processFlow = currentPageParam => {
    let totalPages = Number(totalPageNumber);
    let hasPreviousPage = Number(currentPageParam) === 1 ? false : true;
    let hasNextPage = totalPages && currentPageParam ? Number(currentPageParam) === Number(totalPages) ? false : true : false;
    let last = Number(currentPageParam) + (Number(totalPages) > 5 ? Number(pageSize) : 5) - 1;
    let pageArray = new Array();
    const limitSet = Number(totalPageNumber) > 5 ? Number(currentPageParam) > 3 ? Number(currentPageParam) > 1 ? Number(currentPageParam) - 1 : Number(currentPageParam) : 1 : 1;
    let i = limitSet;
    for (i = limitSet; i <= last; i++) pageArray.push(i);
    setCurrentPage(currentPageParam);
    setPageArray(pageArray);
    setPrevPage(hasPreviousPage);
    setNextPage(hasNextPage);
  };

  // onclick function for the page number, after current page is set need to recalculate the logic and onTriggerPaginationChange is triggered
  const handleClick = pageNumber => {
    setCurrentPage(pageNumber);
    processFlow(pageNumber);
    if (onTriggerPaginationChange) {
      onTriggerPaginationChange({
        data: {
          pageNumber,
          pageSize,
          pageOffset: pageNumber * pageSize - pageSize
        }
      });
    }
  };
  const IsAlphaNumeric = e => {
    e.target.value = e.target.value.trim().replace(/[^\d]/g, '');
  };

  // goTo input field function
  const handleKeyPress = e => {
    if (Number(e.target.value) !== 0 && Number(e.target.value) > totalPageNumber) {
      return;
    }
    // This is perfectly safe in react, it correctly detect the keys
    if (e.key == 'Enter' || e.which === 13) {
      const keyValue = Number(e.target.value);
      handleClick(keyValue);
      setGoToPageNumber('');
    }
  };

  // render method 
  return totalPageNumber > 1 ? /*#__PURE__*/_jsxs("div", {
    className: "kc-ui-pagination",
    children: [hasPreviousPage && /*#__PURE__*/_jsx("button", {
      className: "btn kc-ui-prevBtn",
      onClick: () => handleClick(currentPage - 1),
      type: "button",
      children: "\xA0"
    }), pageArray.includes(1) || pageArray.includes(2) ? null : /*#__PURE__*/_jsx("a", {
      href: "javascript:void(0);",
      onClick: () => handleClick(1),
      children: 1
    }), pageArray.includes(1) || pageArray.includes(2) ? null : /*#__PURE__*/_jsx("span", {
      children: "..."
    }), pageArray && pageArray.length && pageArray.map((value, index) => value <= totalPageNumber && /*#__PURE__*/_jsx("a", {
      href: "javascript:void(0);",
      onClick: () => handleClick(value),
      className: value == currentPage ? "active" : "",
      children: value
    }, value + index)), pageArray.includes(totalPageNumber) || pageArray.includes(totalPageNumber - 1) ? null : /*#__PURE__*/_jsx("span", {
      children: "..."
    }), pageArray.includes(totalPageNumber) ? null : /*#__PURE__*/_jsx("a", {
      href: "javascript:void(0);",
      onClick: () => handleClick(totalPageNumber),
      children: totalPageNumber
    }), hasNextPage && /*#__PURE__*/_jsx("button", {
      className: "btn kc-ui-nextBtn",
      onClick: () => handleClick(currentPage + 1),
      type: "button",
      children: "\xA0"
    }), totalPageNumber > 5 && /*#__PURE__*/_jsxs("div", {
      className: "kc-ui-gotoPage",
      children: ["Go To : ", /*#__PURE__*/_jsx("input", {
        id: "goto",
        className: "kc-ui-form-control",
        type: "number",
        onKeyDown: handleKeyPress,
        onKeyUp: IsAlphaNumeric,
        value: goToPageNumber,
        onChange: e => {
          if (e && e.target && e.target.value && (e.target.value.length > totalPageNumber || Number(e.target.value) > totalPageNumber || Number(e.target.value) === 0)) {
            return;
          }
          setGoToPageNumber(e.target.value);
        }
      })]
    })]
  }) : /*#__PURE__*/_jsx("div", {});
};

// Prop type definition for compile time

// Default props
_Pagination.defaultProps = {
  pageSize: 10,
  totalRecords: 0,
  pageNumber: 1,
  onTriggerPaginationChange: () => {}
};
export const Pagination = /*#__PURE__*/React.memo(_Pagination);